import { Component, ErrorInfo } from "react";
import { reportUnhandledError } from "../utils/error-reporter";

type State = {
  hasError?: {
    error: Error;
    errorInfo: ErrorInfo;
  };
};

export class ErrorBoundary extends Component<
  { children?: React.ReactNode },
  State
> {
  constructor(props: Readonly<{}> | {}) {
    super(props);
    this.state = { hasError: undefined };
  }

  componentDidCatch(e: Error, errorInfo: ErrorInfo) {
    this.setState({
      hasError: {
        error: e,
        errorInfo: errorInfo,
      },
    });
    reportUnhandledError(e);
  }

  render() {
    if (this.state.hasError) {
      <div>エラーが発生しました。</div>;
    }
    return this.props.children;
  }
}
